export default function () {
  let menu = '.menu'
  let $menuToggle = document.querySelectorAll(menu + ' button[aria-haspopup]')
  let $backButton = document.querySelectorAll('.menu__back')
  let $body = document.querySelector('body')
  let bodyDisabledClass = 'is--disabled'

  if ($menuToggle) {
    $menuToggle.forEach(toggle => {
      toggle.addEventListener('click', function () {
        let expanded = this.getAttribute('aria-expanded')

        if (expanded === 'false') {
          // close all other menus
          for (let sibling of this.parentNode.closest('[class*=menu__level]').children) {
            if (sibling !== this.parentNode) {
              let siblingButtons = sibling.querySelectorAll('button[aria-haspopup]')
              siblingButtons.forEach(siblingButton => {
                siblingButton.setAttribute('aria-expanded', false)
              })
            }
          }

          // only open this menu
          this.setAttribute('aria-expanded', true)
        } else {
          this.setAttribute('aria-expanded', false)
        }

        // check if mega menu is active
        if (document.querySelector('.menu__level1 > li > [aria-expanded=true]')) {
          $body.classList.add(bodyDisabledClass)
        } else {
          $body.classList.remove(bodyDisabledClass)
        }
      }, false)
    }, false)
  }

  if ($backButton) {
    $backButton.forEach(toggle => {
      toggle.addEventListener('click', function () {
        let controls = this.getAttribute('data-controls')
        this.parentNode
          .closest(menu)
          .querySelector('[aria-controls=' + controls + ']')
          .setAttribute('aria-expanded', false)
      }, false)
    }, false)
  }

  document.addEventListener('click', function (event) {
    if (event.target !== document.querySelector(menu) &&
      event.target.parentNode.closest(menu) !== document.querySelector(menu)) {
      $menuToggle.forEach(toggle => {
        toggle.setAttribute('aria-expanded', false)
      }, false)
      $body.classList.remove(bodyDisabledClass)
    }
  })
}
